/* Sip With Me: TEA-Lightful Teas — homepage interactions
   Header, cart drawer, search and add-to-cart are native Horizon.
   This handles: scroll reveal, carousels, FAQ accordion, video play. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---- Reveal on scroll ---- */
  function initReveal(root) {
    var els = $$('.swm-reveal', root);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('swm-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('swm-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- Carousels (prev/next + disabled state) ---- */
  function initCarousel(wrap) {
    if (!wrap || wrap.dataset.swmCar) return;
    wrap.dataset.swmCar = '1';
    var track = $('[data-swm-track]', wrap) || wrap;
    var prev = $('[data-swm-dir="-1"]', wrap);
    var next = $('[data-swm-dir="1"]', wrap);
    // controls may live outside the track wrapper (in the head) — search the section
    var section = wrap.closest('.swm-section') || document;
    if (!prev) prev = $('[data-swm-dir="-1"]', section);
    if (!next) next = $('[data-swm-dir="1"]', section);
    function amount() {
      var card = track.querySelector(':scope > *');
      var w = card ? card.getBoundingClientRect().width : 280;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16) || 16;
      return (w + gap) * (window.innerWidth < 640 ? 1 : 2);
    }
    function go(dir) { track.scrollBy({ left: amount() * dir, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    function upd() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---- FAQ accordion ---- */
  function initFaq(root) {
    $$('.swm-acc__q', root).forEach(function (q) {
      if (q.dataset.swmAcc) return; q.dataset.swmAcc = '1';
      q.addEventListener('click', function () {
        var acc = q.parentElement, a = acc.querySelector('.swm-acc__a'), open = acc.classList.contains('swm-open');
        var list = acc.closest('.swm-faq__list') || document;
        $$('.swm-acc.swm-open', list).forEach(function (o) {
          if (o !== acc) { o.classList.remove('swm-open'); o.querySelector('.swm-acc__q').setAttribute('aria-expanded', 'false'); o.querySelector('.swm-acc__a').style.maxHeight = null; }
        });
        if (open) { acc.classList.remove('swm-open'); q.setAttribute('aria-expanded', 'false'); a.style.maxHeight = null; }
        else { acc.classList.add('swm-open'); q.setAttribute('aria-expanded', 'true'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  /* ---- Video: click poster -> load embed (if url) else pulse ---- */
  function initVideo(root) {
    $$('.swm-video[data-swm-video]', root).forEach(function (v) {
      if (v.dataset.swmInit) return; v.dataset.swmInit = '1';
      v.addEventListener('click', playVideo);
      v.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); playVideo.call(v); } });
      function playVideo() {
        var url = v.getAttribute('data-swm-video');
        if (url) {
          var frame = document.createElement('iframe');
          frame.className = 'swm-video__frame';
          frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
          frame.setAttribute('allowfullscreen', '');
          frame.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
          v.innerHTML = '';
          v.appendChild(frame);
        } else {
          var play = v.querySelector('.swm-video__play');
          if (play && play.animate) play.animate([{ transform: 'scale(1)' }, { transform: 'scale(.9)' }, { transform: 'scale(1)' }], { duration: 300 });
        }
      }
    });
  }

  /* ---- Unmute button on autoplay-muted native videos ---- */
  function initUnmute(root) {
    $$('.swm-video__unmute', root).forEach(function (btn) {
      if (btn.dataset.swmInit) return; btn.dataset.swmInit = '1';
      var wrap = btn.closest('.swm-video');
      if (!wrap) return;
      btn.addEventListener('click', function () {
        var vids = wrap.querySelectorAll('video');
        vids.forEach(function (v) { try { v.muted = false; v.volume = 1; v.play(); } catch (e) {} });
        btn.setAttribute('hidden', '');
      });
      /* Hide the button if user unmutes via native controls */
      var vids = wrap.querySelectorAll('video');
      vids.forEach(function (v) {
        v.addEventListener('volumechange', function () { if (!v.muted) btn.setAttribute('hidden', ''); });
      });
    });
  }

  function initAll(root) { initReveal(root); initFaq(root); initVideo(root); initUnmute(root); $$('[data-swm-carousel]', root).forEach(initCarousel); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  /* Theme editor: re-init when a section is reloaded */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
